export const fieldBoxShadow = (colour: string) => `0 0 4px ${colour}`;
